import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledFilterContentContainer = styled(Stack)`
    max-width: 263px;
    gap: 8px;
`;

export const StyledInnerListWrapper = styled(Stack)`
    padding-top: 4px;
    padding-left: 29px;
    gap: 4px;
`;
